<script>
import { Line } from 'vue-chartjs';

export default {
    name: 'BarChart',
    extends: Line,
    data() {
        return {
            datacollection: {},
        };
    },
    mounted() {
        this.fillData();
        this.renderChart(this.datacollection, {
            responsive: true,
            maintainAspectRatio: false,
        });
    },
    methods: {
        fillData() {
            this.datacollection = {
                labels: [this.getRandomInt()],
                datasets: [
                    {
                        label: 'Data One',
                        backgroundColor: '#04C2CA',
                        fill: false,
                        data: [10, this.getRandomInt()],
                    }, {
                        label: 'Data One',
                        backgroundColor: '#FB2453',
                        fill: false,
                        data: [20, this.getRandomInt()],
                    },
                    {
                        label: 'Data One',
                        backgroundColor: '#F3C625',
                        fill: false,
                        data: [25, this.getRandomInt()],
                    },
                    {
                        label: 'Data One',
                        backgroundColor: '#6342CB',
                        fill: false,
                        data: [27, this.getRandomInt()],
                    }, {
                        label: 'Data One',
                        backgroundColor: '#6EB1FF',
                        fill: false,
                        data: [25, this.getRandomInt()],
                    },
                ],
            };
        },
        getRandomInt() {
            return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
        },
    },
};
</script>
